import { render, staticRenderFns } from "./ModalEditTarga.vue?vue&type=template&id=745f8426&"
import script from "./ModalEditTarga.vue?vue&type=script&lang=js&"
export * from "./ModalEditTarga.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTarga.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ModalEditTarga.vue
// module id = 830
// module chunks = 0